$(document).ready(function(){

	$('#toggleSZLogin').on('click', toogleOffcanvas);

	$('.scroll').on('click', function (e) {
		e.preventDefault ? e.preventDefault() : (e.returnValue = false);
		scrollTo($(this).attr("href"));
	});

	function scrollTo (id) {
		$('html, body').animate({ scrollTop: ($(id).offset().top)}, 'slow');
	};

	if ($('.main-sz-szenarien').length != 0) {
		$('.scroll').click(function (event) {
			if ($('#toggleSZLogin').hasClass('active')) {
				toogleOffcanvas(event);
			}
		});
	}

	function toogleOffcanvas(e) {
		e.preventDefault ? e.preventDefault() : (e.returnValue = false);
		$('#toggleSZLogin').toggleClass('active');
		$('.pre-header').toggleClass('in');
		$('.page-wrapper').toggleClass('sz-offcanvas-in');
	}
});

szScrollSpy = function() {

	var jumpPoints;
	var highlightedElement;
	var blockResetingBreakpoints = false;

	var init = function () {

		setBreakpoints();
		checkBreakpoints();

		$(window).scroll(function() {
			checkBreakpoints();
		});

		onElementHeightChange(document.body, function(){
			if (blockResetingBreakpoints) return;
			setTimeout(function() {
				setBreakpoints();
				checkBreakpoints();
			}, 500);
			blockResetingBreakpoints = true;
		});
	}

	function checkBreakpoints () {
		var elementToHighlight;
		for (var i = 0; i < jumpPoints.length; i++) {
			elementToHighlight = jumpPoints[i].nav;
			if ($(window).scrollTop() > jumpPoints[i].breakpoint &&
				jumpPoints[i+1] != null &&
				$(window).scrollTop() < jumpPoints[i+1].breakpoint) {

				break;
			}
		}
		highlightNav(elementToHighlight);
	}

	function setBreakpoints () {
		jumpPoints = [];
		$('#sz-circle-nav a').each(function (index, element) {
			var id = $(element).attr("href");
			jumpPoints.push({
				nav: $(this),
				breakpoint: $(id).offset().top - 300
			});
		});
		blockResetingBreakpoints = false;
		jumpPoints.sort(compare);
	}

	function highlightNav (element) {
		if (highlightedElement == element) return;

		for (var i = 0; i < jumpPoints.length; i++) {
			$(jumpPoints[i].nav).removeClass('active');
		}
		$(element).addClass('active');
		highlightedElement = element;
	}

	function compare(a,b) {
	  if (a.breakpoint < b.breakpoint)
		return -1;
	  else if (a.breakpoint > b.breakpoint)
		return 1;
	  else
		return 0;
	}

	return {
		init: init
	}


	function onElementHeightChange(elm, callback){
		var lastHeight = elm.clientHeight, newHeight;
		(function run(){
			newHeight = elm.clientHeight;
			if( lastHeight != newHeight )
				callback();
			lastHeight = newHeight;

			if( elm.onElementHeightChangeTimer )
				clearTimeout(elm.onElementHeightChangeTimer);

			elm.onElementHeightChangeTimer = setTimeout(run, 500);
		})();
	}
}();

szStart = function() {

	var skip = false;
	var rejectFunction;

	var startAnimation = function () {

		if ($('html').hasClass("vendor-ie-9") ||$('html').hasClass("vendor-ie-8")) {
			$('.sz-animation-container').addClass('keyframe-finished');
			return;
		}

		$('#sz-skip a').click(function (e) {
			e.preventDefault ? e.preventDefault() : (e.returnValue = false);
			skip = !skip;
			if (skip) {
				clearTimeout(timeout);
				rejectFunction();
				$('#sz-skip .sz-skip-text').hide();
				$('#sz-skip .sz-replay-text').show();
			} else {
				$('#sz-skip .sz-replay-text').hide();
				$('#sz-skip .sz-skip-text').show();
				runAnimation();
			}
		})

		runAnimation();
	}

	function runAnimation () {
		Promise.resolve()
		.then(setKeyframe(			 '',  1000))
		.then(setKeyframe( 'keyframe-0', 2500))
		.then(setKeyframe( 'keyframe-1', 1000))
		.then(setKeyframe( 'keyframe-2', 1500))
		.then(setKeyframe( 'keyframe-3', 2000))
		.then(setKeyframe( 'keyframe-4',  500))
		.then(setKeyframe( 'keyframe-5', 2500))
		.then(setKeyframe( 'keyframe-6', 1500))
		.then(setKeyframe( 'keyframe-7', 2000))
		.then(setKeyframe( 'keyframe-8', 2000))
		.then(setKeyframe( 'keyframe-9', 1500))
		.then(setKeyframe('keyframe-10', 2500))
		.then(setKeyframe('keyframe-11', 1500))
		.then(setKeyframe('keyframe-12', 3000))
		.then(setKeyframe('keyframe-13', 1500))
		.then(setKeyframe('keyframe-14', 2500))
		.then(setKeyframe('keyframe-15', 2000))
		.then(cleanUp())
		['catch'](errorHandler); // catch is reserved word in <IE9
	}

	function setKeyframe (name, waitTime) {
		return function (val) {
			var promise = new Promise(function (resolve, reject) {
				setClass(name);
				rejectFunction = reject;
				timeout = setTimeout(function() {
					resolve()
				}, waitTime);
			});
			return promise;
		};
	}

	function setClass (name) {
		var element = document.getElementsByClassName('sz-animation-container')[0];
		element.className = 'sz-animation-container ' + name;
	}

	function cleanUp () {
		return function (val) {
			var promise = new Promise(function (resolve, reject) {
				skip = true;
				$('#sz-skip .sz-skip-text').hide();
				$('#sz-skip .sz-replay-text').show();
				resolve();
			});
			return promise;
		};
	}

	function errorHandler () {
		setClass('keyframe-finished');
	}

	return {
		startAnimation: startAnimation
	}
}();

szThemen = function() {

	var dummyControl;
	var dummyControlMobile;
	var slidesContainer;
	var slidesContainerMobile;
	var contentContainer;
	var themen;

	var init = function() {

		dummyControl = $('.sz-slider .slides li').detach();
		dummyControlMobile = $('.sz-dummy-mobile li').detach();
		slidesContainer = $('.sz-flexslider .slides');
		slidesContainerMobile = $('.sz-dummy-mobile');
		contentContainer = $('.sz-themen-container');
		themen = [];

		$('.sz-thema').each(function (index, element) {
			themen.push(createThema(element));
		});
		activateSlider();
	}

   function createThema (element) {

		var thema = {
			element: $(element).detach().removeClass('sz-hide'),
			toggle: createThemaControl(element, toggleContent),
		}

		return thema;

   }

   function createThemaControl (element, callback) {

		var active = false;

		// clone dummyControl and insert it into slider
		var control = dummyControl.clone();
		slidesContainer.append(control);
		var controlMobile = dummyControlMobile.clone();
		slidesContainerMobile.append(controlMobile);


		// set the headline
		$(control).find('.sz-slider-title span').text($(element).find('.title-h1 span').text());
		$(controlMobile).find('.sz-slider-title').text($(element).find('.title-h1 span').text());

		// add an event listener to the control that sets the state of the image

		var toggleState = function () {

			active = !active;
			if (active) {
				$('html, body').animate({ scrollTop: 0 }, 'slow');
				$(control).find('.sz-slider-item').addClass('sz-active');
				$(controlMobile).find('.sz-slider-item').addClass('sz-active');

			} else {
				$(control).find('.sz-slider-item').removeClass('sz-active');
				$(controlMobile).find('.sz-slider-item').removeClass('sz-active');
			}

			callback(active, element);
		};

		var controlElement = $(control).find('.sz-slider-control');
		var controlElementMobile = $(controlMobile).find('.sz-slider-control');
		$(controlElement).parent().click(toggleState);
		$(controlElementMobile).parent().parent().click(toggleState);

   }

	function toggleContent (active, element) {

		if (active) {
			$(contentContainer).prepend($(element).hide());
			$(element).fadeIn('slow');
		} else {
			$(element).fadeOut('fast', function () {
				$(element).remove();
			});
		}
	}

	function activateSlider () {
		$('.sz-flexslider').flexslider({
			animation: "slide",
			animationLoop: true,
			itemWidth: 220,
			minItems: 4,
			maxItems: 4,
			slideshow: false,
			controlNav: false,
			prevText: '<span class="sz-slider-control-left">zurück</span>',
			nextText: '<span class="sz-slider-control-right">weiter</span>',
			start: function () {
				$('.sz-navigation').removeClass('out');
			}
		});
	}

	return {
		init: init
	}
}();
